import { SmileSimulationLogo } from "./SmileSimulationLogo";
import { SplashLoadingDots } from "./SplashLoadingDots";

type SmileSimulationAuthLoadingPageProps = {
  isTimedOut?: boolean;
  onRefresh: () => void;
  onRetry: () => void;
};

export function SmileSimulationAuthLoadingPage({
  isTimedOut = false,
  onRefresh,
  onRetry,
}: SmileSimulationAuthLoadingPageProps) {
  return (
    <main
      className="flex h-screen items-center justify-center bg-white px-6 py-12"
      style={{ height: "100svh" }}
    >
      <section className="w-full max-w-sm text-center">
        <SmileSimulationLogo className="mx-auto h-auto w-[180px]" />
        <h1 className="mt-10 text-2xl font-bold tracking-tight text-gray-900">
          인증 상태를 확인하고 있어요
        </h1>
        <p className="mt-3 text-sm leading-6 text-gray-600">
          {isTimedOut
            ? "평소보다 오래 걸리고 있어요. 다시 시도하거나 화면을 새로고침해 주세요."
            : "잠시만 기다려 주세요."}
        </p>
        <div className="flex justify-center">
          <SplashLoadingDots />
        </div>
        {isTimedOut ? (
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={onRetry}
              className="w-full rounded-full bg-[#6750a4] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#58428f] focus:outline-none focus:ring-2 focus:ring-[#6750a4] focus:ring-offset-2"
            >
              다시 시도
            </button>
            <button
              type="button"
              onClick={onRefresh}
              className="w-full rounded-full border border-gray-300 bg-white px-5 py-3 text-sm font-semibold text-gray-800 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#6750a4] focus:ring-offset-2"
            >
              새로고침
            </button>
          </div>
        ) : null}
      </section>
    </main>
  );
}
